import * as actions from '../actions/newUser';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenSequentially from 'xstream/extra/flattenSequentially';

export function requestDeleteAragUser(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.DELETE_ARAG_USER)
        .map(action => ({
            url: BASE_URL + 'api/users/AragUsers/' + action.payload.userId,
            category: 'requestDeleteAragUser',
            method: 'DELETE',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the posted new user
    let httpResponse$ = sources.HTTP
        .select('requestDeleteAragUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status === 200)
        .map(response => actions.deleteAragUserSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function requestDeleteAragUserFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestDeleteAragUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.deleteAragUserFail(response));

    return {
        ACTION: httpResponse$
    }
}

export function requestResetAragUserPassword(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RESET_ARAG_USER_PASSWORD)
        .map(action => ({
            url: BASE_URL + 'api/users/AragUsers/Password?userId=' + action.payload.userId,
            category: 'requestResetAragUserPassword',
            method: 'POST',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the posted new user
    let httpResponse$ = sources.HTTP
        .select('requestResetAragUserPassword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.resetAragUserPasswordSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function requestResetAragUserPasswordFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestResetAragUserPassword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.resetAragUserPasswordFail(response));

    return {
        ACTION: httpResponse$
    }
}

export function postNewUser(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_NEW_USER)
		.map(action => ({
			url: BASE_URL + 'api/adminManageUsers/user',
			category: 'postNewUser',
			method: 'POST',
			type: 'application/json',
			send: action.payload.user,
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http post requests, it updates the redux store with the posted new user
	let httpResponse$ = sources.HTTP
		.select('postNewUser')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receivePostNewUserResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedPostNewUser(sources) {
	let httpResponse$ = sources.HTTP
		.select('postNewUser')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadResponsePostNewUser(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}

export function patchUser(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_EDIT_USER)
		.map(action => ({
			url: BASE_URL + 'api/users/aragusers/'+action.payload.user.id,
			category: 'patchUser',
			method: 'PATCH',
			type: 'application/json',
			send: action.payload.user,
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http post requests, it updates the redux store with the posted new user
	let httpResponse$ = sources.HTTP
		.select('patchUser')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
        .compose(flattenSequentially)
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchUserResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedPatchUser(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchUser')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadResponsePatchUser(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}
